$(function(){
	// quiz
	var quizCloseBtn =  $('.jsCloseQuiz').click(function(e){
		e.preventDefault();
		closeQuiz();
	});
	var quizShowBtn = $('.jsOpenQuiz').click(function(e){
		e.preventDefault();
		openQuiz();
	});

	var launchQuiz = getURLParameter("launchQuiz");

	function openQuiz() {
		var quiz = $('#quiz');
		if( !quiz.hasClass('quiz--show')) {
			quiz.addClass('quiz--show');
		}
	}

	function closeQuiz() {
		var quiz = $('#quiz');
		if( quiz.hasClass('quiz--show')) {
			quiz.removeClass('quiz--show');
		}
	}

	if (launchQuiz) {
		$(".jsOpenQuiz").click();
	}

});
